if (!customElements.get('freelife-announcement')) {
  customElements.define(
    'freelife-announcement',
    class FreeLifeAnnouncement extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.slides = [...this.querySelectorAll('[data-announcement-slide]')].filter((slide) => this.isCurrent(slide));
        this.index = 0;
        this.paused = false;

        if (this.dataset.dismissible === 'true' && this.isDismissed()) {
          this.hidden = true;
          return;
        }

        this.querySelectorAll('[data-announcement-slide]').forEach((slide) => {
          slide.hidden = !this.slides.includes(slide) || slide !== this.slides[0];
        });

        if (!this.slides.length) {
          this.hidden = true;
          return;
        }

        const options = { signal: this.controller.signal };
        this.querySelector('[data-announcement-previous]')?.addEventListener('click', () => this.show(this.index - 1), options);
        this.querySelector('[data-announcement-next]')?.addEventListener('click', () => this.show(this.index + 1), options);
        this.querySelector('[data-announcement-toggle]')?.addEventListener('click', () => this.toggle(), options);
        this.querySelector('[data-announcement-dismiss]')?.addEventListener('click', () => this.dismiss(), options);
        this.addEventListener('mouseenter', () => this.stop(), options);
        this.addEventListener('mouseleave', () => this.start(), options);
        this.addEventListener('focusin', () => this.stop(), options);
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.start();
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          const selected = this.slides.indexOf(event.target);
          if (selected >= 0) this.show(selected, false);
        }, options);
        this.start();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.stop();
      }

      isCurrent(slide) {
        const now = Date.now();
        const start = Date.parse(slide.dataset.campaignStart || '');
        const end = Date.parse(slide.dataset.campaignEnd || '');
        return (!Number.isFinite(start) || now >= start) && (!Number.isFinite(end) || now <= end);
      }

      show(nextIndex, resume = true) {
        if (!this.slides.length) return;
        this.index = (nextIndex + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => { slide.hidden = index !== this.index; });
        if (resume) this.start();
      }

      start() {
        this.stop();
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay !== 'true' || this.paused || reduceMotion || this.slides.length < 2) return;
        this.timer = window.setInterval(() => this.show(this.index + 1, false), Number(this.dataset.interval) || 6000);
      }

      stop() {
        window.clearInterval(this.timer);
      }

      toggle() {
        this.paused = !this.paused;
        const button = this.querySelector('[data-announcement-toggle]');
        button?.setAttribute('aria-pressed', String(this.paused));
        button?.setAttribute('aria-label', this.paused ? 'Automatischen Wechsel starten' : 'Automatischen Wechsel pausieren');
        if (button) {
          button.querySelector('[data-pause-icon]').hidden = this.paused;
          button.querySelector('[data-play-icon]').hidden = !this.paused;
        }
        this.paused ? this.stop() : this.start();
      }

      storageKey() {
        return `freelife-announcement-${this.dataset.sectionId}-${this.dataset.dismissVersion || '1'}`;
      }

      isDismissed() {
        try {
          return Number(localStorage.getItem(this.storageKey())) > Date.now();
        } catch (error) {
          return false;
        }
      }

      dismiss() {
        const days = Number(this.dataset.dismissDays) || 7;
        try {
          localStorage.setItem(this.storageKey(), String(Date.now() + days * 86400000));
        } catch (error) {
          // The bar can still be dismissed for this page view when storage is unavailable.
        }
        this.hidden = true;
        this.stop();
      }
    }
  );
}
